import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'common/components/core/base-form.component';
import { OperationType, Question_Type } from 'common/constants/sm-constants';
import { FeedbackModel } from 'common/models/page-models/feedback/feedback-data-model';
import { RouteEnvelope } from 'common/models/utility-models/base-model';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { FormMetaModel } from 'common/models/utility-models/meta-model';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackFormWidgetService } from 'common/widget/feedback/feedback-form-widget';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent
  extends BaseFormComponent<FeedbackModel>
  implements OnInit, AfterViewInit
{
  constructor(
    protected aRoute: ActivatedRoute,
    protected ws: FeedbackFormWidgetService,
    protected ss: SystemService,
    private fb: FormBuilder
  ) {
    super(aRoute, ws, ss);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    // console.log('feedBack Code');

    // this.initForm.get('questions').setErrors(null)
    // this.populateCategories()
  }

  ngAfterViewInit(): void {
    if (!this.pageData.id) {
      this.addQuestions();
      this.addCategories();
    } else {
      if (this.pageData.categories.length !== 0) {
        this.pageData.categories.forEach((value) => {
          this.addCategories(value.category);
        });
      } else {
        this.addCategories('');
      }

      this.pageMeta.properties.questions.fields.selected_category_text.options =
        this.categoriesList().value;
      this.pageData.questions.forEach((question, index) => {
        // question.question_type = Question_Type.filter((que, index) => {
        //  return que.question_type ===  question.question_type
        // })[0].name
        this.addQuestions(question);
        question.options.forEach((option) => {
          this.addOptions(index, option);
        });
      });

     
    }
  }

  override addFormControl(
    element: any,
    pageMeta: FormMetaModel | any,
    formGroup: FormGroup | any
  ): void {
    // console.log(this.pageData);
    // console.log(Array.isArray(this.pageData[element]), 'array');
    formGroup.addControl(
      element,
      Array.isArray(this.pageData[element])
        ? new FormArray([])
        : new FormControl(this.pageData[element])

      //    formGroup.addControl(element, new FormControl(null));
    );
    if (pageMeta.properties[element] !== undefined) {
      this.addFieldValidation(element, pageMeta.properties[element], formGroup);
    }
  }

  //     onFeedbackSubmit() {
  //         console.log(this.initForm.value);
  //     this.onSubmit()

  //   }

  navigateToTable() {
    const envelope = new RouteEnvelope();
    envelope.type = OperationType.VIEW;
    envelope.transferData = new GridParams();
    this.systemService.navigateByUrl(this.pageMeta.redirectPath, envelope);
  }

  addCategories(categories: string = '') {
    const categoriesArr = this.initForm.get('categories') as FormArray;
    const categoriesObj = this.fb.group({
      category: new FormControl(categories === null ? '' : categories),
    });
    categoriesArr.push(categoriesObj);
  }

  addQuestions(questionObj: any = null) {
    const questionArr = this.initForm.get('questions') as FormArray;
    const questionObjArr = this.fb.group({
      id: new FormControl(questionObj === null ? '' : questionObj.id),
      question_text: new FormControl(
        questionObj === null ? '' : questionObj.question_text,
        [Validators.required]
      ),
      selected_category_text: new FormControl(
        questionObj === null ? '' : questionObj.selected_category_text
      ),
      question_type: new FormControl(
        questionObj === null ? '' : questionObj.question_type,
        [Validators.required]
      ),
      options: new FormArray([]),
    });
    // console.log(questionObj,'questionObjArr');
    questionArr.push(questionObjArr);
    // console.log(questionArr,'questionArr');
  }

  categoriesList(): FormArray {
    return this.initForm.get('categories') as FormArray;
  }

  getQuestionList(): FormArray {
    return this.initForm.get('questions') as FormArray;
  }

  removeCategory(index: number) {
    this.categoriesList().removeAt(index);
    this.pageMeta.properties.questions.fields.selected_category_text.options =
      this.categoriesList().value;
  }

  removeQuestiolist(index: number) {
    this.getQuestionList().removeAt(index);
  }

  getQuestionListOption(index): FormArray {
    const questionOptionConrol = this.getQuestionList().at(index);
    const option = questionOptionConrol.get('options') as FormArray;
    return option;
  }

  addOptions(index: number, optionObj: any = null) {
    // console.log(index, 'index');
    const questionOptionConrol = this.getQuestionList().at(index);
    const option = questionOptionConrol.get('options') as FormArray;
    const optionForm = this.fb.group({
      id: new FormControl(optionObj === null ? '' : optionObj.id),
      option_text: new FormControl(
        optionObj === null ? '' : optionObj.option_text,
        [Validators.required]
      ),
    });
    // console.log(option,optionForm,'addOptions')
    option.push(optionForm);
  }

  removeOptionList(questionIndex: number, optionIndex: number) {
    this.getQuestionListOption(questionIndex).removeAt(optionIndex); 
  }

  override checkUpdatedForm() {
    let count = 0;
    // console.log("Initial count:", count);

    // Fetch the condition if required for additional count increment
    let condition = this.addOnEditCondition();

    // Iterate through the keys in the form
    Object.keys(this.initForm.value).forEach((key: string) => {
        const formValue = this.initForm.value[key];
        const originalValue = this.pageData[key];
        const isFormControl = this.pageMeta.properties[key]?.isFormControl !== false;

        // Log the comparison for debugging
        // console.log(`Key: ${key}, Form Value: ${formValue}, Original Value: ${originalValue}, Is Form Control: ${isFormControl}`);

        // Increment count if the value has changed and it is a form control
        if (isFormControl && formValue !== originalValue) {
            count++;
            // console.log(`Count increased due to key: ${key}`);
        }
    });

    // Increment count if the additional condition is true
    if (condition) {
        count++;
        // console.log('Count increased due to additional condition');
    }

    // console.log("Final count:", count);
    return count;
}



  

  onSelectedQuestion_type(value, index) {
    if ([1, 4, 6].includes(value)) {
      this.resetOptionListArr(index);
      this.addOptions(index);
    } else {
      this.resetOptionListArr(index);
    }
  }

  performInputAction(event, index) {
    //console.log(event,index,this.categoriesList().value, '');
    this.pageMeta.properties.questions.fields.selected_category_text.options =
      this.categoriesList().value;
  }

  resetOptionListArr(index) {
    // console.log(index);
    const getOptionList = this.getQuestionListOption(index);
    getOptionList.clear();
  }
}
